import { Shop } from '../models/shop';
import { DaySchedule } from '../models/submodels/timetable';
import { MyTime, TimeHelper } from './time-helper';

export class ShopHelper {

  static getArrivalTimes(shop: Shop) {
    const currentTime = TimeHelper.getCurrentTime();
    const currentTimeInMinutes = TimeHelper.timeToMinutes(currentTime);
    const preparationTime = TimeHelper.parse(shop.preparationTime);
    const preparationTimeInMinutes = TimeHelper.timeToMinutes(preparationTime);
    const todaySchedule = this.getTodaySchedule(shop);

    const times: MyTime[] = [];
    let timeInMinutes = currentTimeInMinutes + TimeHelper.minutes(shop.preparationTime) + 15;
    timeInMinutes = Math.round(timeInMinutes / 15) * 15;

    todaySchedule.workingPeriods.forEach((workingPeriod) => {
      const startTime = TimeHelper.parse(workingPeriod.startTime);
      const endTime   = TimeHelper.parse(workingPeriod.endTime);

      const from = TimeHelper.minutesToTime( TimeHelper.timeToMinutes(startTime) + preparationTimeInMinutes);
      const to = TimeHelper.minutesToTime( TimeHelper.timeToMinutes(endTime) + preparationTimeInMinutes );
      while (timeInMinutes < TimeHelper.timeToMinutes(to)) {
        if (TimeHelper.isWithinTimeSpan(TimeHelper.minutesToTime(timeInMinutes), from, to)) {
          times.push(TimeHelper.minutesToTime(timeInMinutes));
        }
        timeInMinutes += 15;
      }
    });

    return times;
  }

  static earliestArrivalTime(shop: Shop) {
    const arrivalTimes = this.getArrivalTimes(shop);
    return arrivalTimes[0];
  }

  static latestArrivalTime(shop: Shop) {
    const arriavalTimes = this.getArrivalTimes(shop);
    return arriavalTimes[arriavalTimes.length];
  }

  static getTodaySchedule(shop: Shop) {
    const today = TimeHelper.getCurrentDay();
    return shop.timetable[today] as DaySchedule;
  }

  static isOpenOn(shop: Shop, day: string, time: MyTime) {
    const daySchedule = shop.timetable[day] as DaySchedule;

    if (daySchedule.isClosed) { return false; }

    for (const workingPeriod of daySchedule.workingPeriods) {
      const startTime = TimeHelper.parse(workingPeriod.startTime);
      const endTime = TimeHelper.parse(workingPeriod.endTime);
      if (TimeHelper.isWithinTimeSpan(time, startTime, endTime)) { return true; }
    }

    return false;
  }

  static isOpenTodayAt(shop: Shop, time: MyTime) {
    const today = TimeHelper.getCurrentDay();
    return this.isOpenOn(shop, today, time);
  }

  static isOpenToday(shop: Shop) {
    const today = TimeHelper.getCurrentDay();
    return !shop.timetable[today].isClosed;
  }

  static isClosedToday(shop: Shop) {
    const today = TimeHelper.getCurrentDay();
    return shop.timetable[today].isClosed;
  }

}
